module.exports = __webpack_public_path__ + "img/Beschermende-kleding_verplicht.026861bb.jpg";